import React from "react";
import { PuffLoader } from "react-spinners";

export const RingLoader = () => {
  return <PuffLoader color="#6da9b3" size={100} />;
};
